<template>
    <div class="mine">

        <van-nav-bar
                title="个人基础信息列表"
                fixed
                placeholder
            />

        <van-notice-bar
            left-icon="volume-o"
            text="如在使用过程中出现任何疑问和建议，请联系相关业务人员对应处理。"
        />
        <van-cell-group style="margin-top:15px">
            <van-cell title="员工账号" value="内容">
            <!-- 使用默认插槽自定义内容 -->
                <div>{{name}}</div>
            </van-cell>
        </van-cell-group>

        <van-cell-group style="margin-top:5px">
            <van-cell title="员工名称" value="内容">
                <div>{{ladyName}}</div>
            </van-cell>
            <van-cell title="手机号码" value="内容">
                <div>{{tel}}</div>
            </van-cell>
            <van-cell title="注册时间" value="内容">
                <!-- 使用 title 插槽自定义标题 -->
                <template #default>
                    <div>{{distribution}}</div>
                </template>
            </van-cell>
        </van-cell-group>

        <van-notice-bar
            wrapable
            color="#1989fa"
            background="#ecf9ff"
            style="text-align: left"
            :scrollable="false"
            text="如在使用过程中出现任何疑问和建议，请联系相关业务人员对应处理。"
        />

        

    </div>
</template>

<script>

    import {AccountInfo} from "@/api/Mine";
    import {SystemRule} from "@/api/Login";
    import { Cell, CellGroup, Icon } from 'vant';
    import { Divider } from 'vant';
    import { NavBar } from 'vant';
    import { Dialog } from 'vant';
    import { NoticeBar } from 'vant';
    import Vue from 'vue';
    Vue.use(Cell);
    Vue.use(CellGroup);
    Vue.use(NavBar);
    Vue.use(Icon);
    Vue.use(Divider);
    Vue.use(Dialog);
    Vue.use(NoticeBar)
    export default {
        name: "MineInfo",
        data(){
            return{
                ladyName: '',
                name: '',
                tel: '',
                distribution: '',
                dcTel: '',

                title: '提示',
                messageVisible: false,
                message: "",

                ruleContent: '',
            }
        },

        mounted() {
            this.mineInfo();
            this.requestRule();
        },

        methods: {
            close() {
                this.messageVisible = false;
                this.$emit('close');
            },
            //是否退出登录
            okCancel() {
                this.$store.dispatch('Logout', this.loginForm)
                    .then(() => {
                        this.$cookies.set("openid", '');
                        this.$router.go(-1);
                    })
            },

            mineInfo(){
                AccountInfo()
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.ladyName = response.data.ladyName;
                            this.name = response.data.username;
                            this.tel = response.data.ladyTel;
                            this.distribution = response.data.distributionCenterName;
                            this.dcTel = response.data.distributionCenterTel;

                        }
                    });
            },

            handleEdit(ladyName, name, tel) {
                this.$router.push({path: '/mineDetail', query: {ladyName, name, tel}})
            },

            logout() {
                this.messageVisible = true;
                this.message = '是否退出登录？';
            },

            requestRule() {
                SystemRule()
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.ruleContent = response.data.value;

                        }
                    });
            }


        }

    }
</script>

<style lang="scss">
    .mine {
        margin: 20px 0 120px 0;

        .van-cell__title{   // sass 修改子组件样式  /deep/ 或者 >>>
            text-align: left;
        }

        .mine-title {
            margin-left: 30px;
        }

        p {
            margin: 10px;
            margin-block-start: 0em;
            margin-block-end: 0em;
            text-align: left;
        }

        .mine-content {
            width: 85%;
            margin-left: 30px;
            font-size: 0.9rem;
            margin-top: 20px;
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #000000;
            background: #FFFFFF;

            div {
                height: 30px;
                margin-top: 10px;
                margin-bottom: 10px;
                margin-top: 20px;
                border-bottom: 1px solid #BDBDBD;
            }

            p {
                float: left;
                width: 120px;
                text-align: left;
            }

            label {
                float: right;
            }

            input {
                float: right;
                width: 70%;
            }
        }

        .button {
            width: 85%;
            padding: 10px;
            margin: 10px auto;
            color: #FFFFFF;
            font-size: 1rem;
            border-radius: 5px;
            background: #2d8cf0;
        }

        .mine-rules {
            margin-top: 20px;
            margin-left: 30px;
        }

        .content-tip {
            text-align: left;
            width: 85%;
            font-size: 0.9rem;
            padding: 10px;
            border-radius: 5px;
            margin-top: 20px;
            margin-left: 30px;
            border: 1px solid #000000;
            background: #FFFFFF;

            p {
                text-align: left;
                font-size: 0.8rem;
            }
        }

        .logout {
            color: white;
            background: red;
            margin-top: 20px;
            font-size: 1rem;
            padding: 10px;
        }
    }
</style>